import { Action } from '@ngrx/store';

export class ResearchActions implements Action {

    public static getIndex: string = '[Research] get_index';
    public static getIndexError: string = '[Research] get_index_error';
    public static getIndexSuccess: string = '[Research] get_index_success';

    public static getIndexQuote: string = '[Research] get_index_quote';
    public static getIndexQuoteError: string = '[Research] get_index_quote_error';
    public static getIndexQuoteSuccess: string = '[Research] get_index_quote_success';

    public static getTaxTable: string = '[Research] get_tax_table';
    public static getTaxTableError: string = '[Research] get_tax_table_error';
    public static getTaxTableSuccess: string = '[Research] get_tax_table_success';

    public static getIndexAgregated: string = '[Research] get_index_agregated';
    public static getIndexAgregatedError: string = '[Research] get_index_agregated_error';
    public static getIndexAgregatedSuccess: string = '[Research] get_index_agregated_success';

    public static getPriceBands: string = '[Research] get_price_bands';
    public static getPriceBandsError: string = '[Research] get_price_bands_error';
    public static getPriceBandsSuccess: string = '[Research] get_price_bands_success';

    public static getOpportunities: string = '[Research] getOpportunities';
    public static getOpportunitiesError: string = '[Research] getOpportunitiesError';
    public static getOpportunitiesSuccess: string = '[Research] getOpportunitiesSuccess';

    public static getOpportunity: string = '[Research] getOpportunity';
    public static getOpportunityError: string = '[Research] getOpportunityError';
    public static getOpportunitySuccess: string = '[Research] getOpportunitySuccess';

    public static reasearchAdvicesSubscribe: string = '[Research] reasearchAdvicesSubscribe';
    public static reasearchAdvicesSubscribeError: string = '[Research] reasearchAdvicesSubscribe_error';
    public static reasearchAdvicesSubscribeSuccess: string = '[Research] reasearchAdvicesSubscribe_success';
    public static reasearchCleanAdvice: string = '[Research] reasearchCleanAdvice';

    public static reasearchAdvicesUnsubscribe: string = '[Research] reasearchAdvicesUnsubscribe';
    public static reasearchAdvicesUnsubscribeError: string = '[Research] reasearchAdvicesUnsubscribe_error';
    public static reasearchAdvicesUnsubscribeSuccess: string = '[Research] reasearchAdvicesUnsubscribe_success';

    public static loadCategories = '[Research] load_categories';
    public static loadCategoriesSuccess = '[Research] load_categories_success';
    public static loadCategoriesError = '[Research] load_categories_error';

    public static mergeNewCategory = '[Research] merge_new_category';

    constructor(
        public type: string,
        public payload?: any,
    ) {}

}
